/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EventPatternSyntax } from '../../../../Services/event-bus/src/EventBus.service.defs';
import { AttributeFilter } from '../../forms/EventSubscriptionBuilderForm/EventSubscriptionBuilderForm.defs';
import { convertToEventSyntax } from '../ConvertToEventSyntax/ConvertToEventSyntax';

/**
 * Converts the provided attribute filters into a syntax which is compatible with the
 * event bus service and also combines the filters with logical AND.
 * @param {Array<AttributeFilter>} attributeFilters The list of provided attribute filter objects.
 * @returns {EventPatternSyntax} The map of the attribute filters defined in event pattern syntax.
 */
export const convertToEventPattern = (attributeFilters: Array<AttributeFilter>): EventPatternSyntax => {
  return attributeFilters.reduce((eventPatternObject, filter) => {
    eventPatternObject[filter.name] = convertToEventSyntax(filter.rule, filter.value);
    return eventPatternObject;
  }, {} as EventPatternSyntax);
};
